import { render, staticRenderFns } from "./Chip.vue?vue&type=template&id=4b0a17b8&scoped=true"
import script from "./Chip.vue?vue&type=script&lang=js"
export * from "./Chip.vue?vue&type=script&lang=js"
import style0 from "./Chip.vue?vue&type=style&index=0&id=4b0a17b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0a17b8",
  null
  
)

export default component.exports